import { render, staticRenderFns } from "./BaseFilterReport.vue?vue&type=template&id=8696e734&scoped=true&"
import script from "./BaseFilterReport.vue?vue&type=script&lang=js&"
export * from "./BaseFilterReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8696e734",
  null
  
)

export default component.exports